/**
 * Created by Qingger Corp.
 * User: tanjianzhen
 * Date: 2018-6-26
 * Time: 13:14
 * Desc:
 */
import MSDataTransfer from './dataTranslate';
import validateParams from './paramFilter';
export default {
  MSDataTransfer,
  validateParams,
};
